import React, { useEffect, useState } from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import { readableColor } from "polished";
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import SwipeRightIcon from '@mui/icons-material/SwipeRight';
import SwipeIcon from '@mui/icons-material/Swipe';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export const ProgressTable = ({ children, headers, sortConfig, onSort }) => {
  const theme = useTheme();
  const [contrastColor, setContrastColor] = React.useState("#fff");
  const [showSwipeIndicators, setShowSwipeIndicators] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (theme) {
      setContrastColor(readableColor(theme.mode === "dark" ? theme.colors.backgroundPendienteLight : theme.colors.backgroundPendienteDark));
    }
  }, [theme]);

  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      const ua = navigator.userAgent;
      const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
      setIsMobile(iOS || isMobileDevice);
    };
    
    checkMobile();
    
    // Auto-hide indicators after 5 seconds
    if (isMobile) {
      const timer = setTimeout(() => {
        setShowSwipeIndicators(false);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="relative flex flex-col w-full h-full overflow-hidden bg-clip-border rounded-[8px]"
      style={{
        backgroundColor: theme.mode === "dark" ? theme.colors?.backgroundColorNotCurrentModule : theme.colors?.background_secondary?.backgroundColor,
      }}
    >
      {/* Swipe indicators - only shown on mobile */}
      {isMobile && showSwipeIndicators && (
        <>
          {/* Horizontal swipe indicator */}
          <div 
            className="absolute top-[2.2rem] left-0 right-0 flex justify-end px-4 z-10 pointer-events-none animate-pulse "
            style={{ transform: 'translateY(-50%)' }}
          >
            <SwipeIcon 
              sx={{ 
                fontSize: '3.8rem', 
                color:  '#fff',
                fill:  theme.mode === "dark" ? "#000" : "#fff",
                /* backgroundColor: 'rgba(255,255,255,0.7)', */
                borderRadius: '50%',
                padding: '4px',
                opacity: setTimeout(() => {
                  return 0;
                }, 5000),
               
              }} 
            />
          </div>
          
          {/* Hint text */}
         {/*  <div 
            className="absolute bottom-2 left-0 right-0 text-center pointer-events-none"
            style={{
              color: theme.colors.primary || '#000',
              backgroundColor: 'rgba(255,255,255,0.7)',
              padding: '4px 8px',
              borderRadius: '4px',
              margin: 'auto',
              width: 'fit-content',
              opacity: setTimeout(() => {
                return 0;
              }, 5000),
            }}
          >
            <p className="text-lg font-medium">Desliza para ver más</p>
          </div> */}
        </>
      )}

      {/* Table */}
      <div className="w-full h-full overflow-auto rounded-[8px]" style={{
        backgroundColor: theme.mode === "dark" ? theme.colors?.backgroundColorNotCurrentModule : "#FFFFFF",
      }}>
        <table className="w-full text-left table-auto min-w-[700px] laptop:min-w-0 border-collapse">
          <thead>
            <tr style={{
              backgroundColor: theme.mode === "dark" ? theme.colors?.backgroundColorNotCurrentModule : "#FFFFFF",
              borderBottom: theme.mode === "dark" ? "1px solid rgba(255,255,255,0.1)" : "1px solid #e2e8f0",
            }}>
              {headers &&
                headers.map((h, idx) => {
                  const isObject = typeof h === "object" && h !== null;
                  const label = isObject ? h.label : h;
                  const key = isObject ? h.key : null;
                  const width = isObject ? h.width : undefined;
                  const sortable = isObject && h.sortable !== false && typeof onSort === "function";
                  const isSorted = Boolean(sortConfig && sortConfig.key === key);
                  const direction = isSorted ? sortConfig.direction : null;

                  return (
                    <th
                      className={`p-4 border-none ${sortable ? "cursor-pointer select-none group transition-colors" : ""}`}
                      key={key || idx}
                      scope="col"
                      style={width ? { width, minWidth: width } : undefined}
                      onClick={sortable ? () => onSort(key) : undefined}
                      aria-sort={isSorted ? (direction === "asc" ? "ascending" : "descending") : "none"}
                      role={sortable ? "button" : undefined}
                      tabIndex={sortable ? 0 : undefined}
                      onKeyDown={
                        sortable
                          ? (e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                onSort(key);
                              }
                            }
                          : undefined
                      }
                    >
                      <div className="flex items-center gap-1.5">
                        <p
                          className={`block text-[11px] leading-none font-medium uppercase transition-colors whitespace-nowrap ${
                            isSorted ? "font-bold" : ""
                          }`}
                          style={{
                            color: isSorted
                              ? (theme.mode === "dark" ? "#FFFFFF" : "#111827")
                              : "#757575",
                          }}
                        >
                          {label}
                        </p>
                        {sortable && (
                          <span
                            className={`inline-flex items-center transition-all duration-150 ${
                              isSorted
                                ? "opacity-100 scale-100"
                                : "opacity-0 group-hover:opacity-40 scale-90"
                            }`}
                          >
                            {isSorted && direction === "desc" ? (
                              <ArrowDownwardIcon
                                sx={{
                                  fontSize: 14,
                                  color: theme.mode === "dark" ? "#FFFFFF" : "#111827",
                                }}
                              />
                            ) : (
                              <ArrowUpwardIcon
                                sx={{
                                  fontSize: 14,
                                  color: isSorted
                                    ? (theme.mode === "dark" ? "#FFFFFF" : "#111827")
                                    : "#757575",
                                }}
                              />
                            )}
                          </span>
                        )}
                      </div>
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  );
};